import HelloSign from 'hellosign-embedded';
import { SaveClientSignatureRequestInfoExtras } from '../document/SaveAndLoadDocument';
import { SaveClientSignatureRequestInfo } from '../document/SaveAndLoadDocument';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs, { extend } from 'dayjs';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';

export async function GetDocumentByInfoExtras(
	firebase,
	expandedClient,
	client,
	documentInfo,
	authToken,
	adminEmail,
	theseCustomFields,
	theseCustomSigners,
	useSecondPurchaser
) {
	if (theseCustomFields === null || theseCustomFields === undefined) {
		theseCustomFields = [];
	}

	//console.log("Client Json " + JSON.stringify(client));

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	console.log('Current auth token ' + authToken);

	var jsonInfo = {
		authToken: authToken,
		senderEmail: adminEmail,
		subjectName: documentInfo.subjectName,
		message: documentInfo.message,
		projectCode: PROJECT_CODE.projectCode,
		templateId: documentInfo.templateId,
		clientEmail: client.clientEmail,
		clienFullName: client.fullName,
		customFields: theseCustomFields,
	};

	if(theseCustomSigners !== undefined){
		jsonInfo['newSigners'] = theseCustomSigners;
		jsonInfo['overideSigners'] = true;
		jsonInfo['overideMetaData'] = true;
		jsonInfo['newMetaData'] = {'my_client': client.clientEmail}
	}

	if(useSecondPurchaser === true){
		if(documentInfo.secondPurchaserTemplateId !== undefined){
			jsonInfo['templateId'] = documentInfo.secondPurchaserTemplateId;
			jsonInfo['secondClientEmail'] = client.documentInformation.document.individualSecondPurchaserDetails?.email
			jsonInfo['secondClientFullName'] = client.documentInformation.document.individualSecondPurchaserDetails?.firstName + " " + client.documentInformation.document.individualSecondPurchaserDetails?.lastName;
			getDoc = firebase.functions().httpsCallable('HelloSignCallDocumentSecondPurchaser');

			//secondClientFullName
			//jsonInfo['secondClientEmail'] = client.documentInformation.document.
		}
	}


	var finishedData;

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ' + signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: 'beab0930839f98ade6e9af78da0ed230',
		});
	};

	helloClient.on('finish', () => {
		SaveClientSignatureRequestInfoExtras(
			firebase,
			finishedData,
			client.clientEmail,
			documentInfo.subjectName
		);
	});

	getDoc(jsonInfo)
		.then((result) => {
			//setLoading(false);
			console.log('doc result: ' + JSON.stringify(result['data']['claim_url']));
			displayHelloDoc(result['data']['claim_url']);

			// SaveClientSignatureRequestInfoExtras(
			// 	firebase,
			// 	result['data'],
			// 	client.clientEmail,
			// 	documentInfo.subjectName
			// );
			finishedData = result['data'];
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});
}

export async function GetDocumentByInfoAPS(
	firebase,
	client,
	documentInfo,
	authToken,
	adminEmail,
	buildingPriceWord,
	buildingPrice,
	elevationId,
	clientPostalCode,
	clientAddress,
	buildingName,
	secondIndividual,
	setLoading
) {
	//console.log("Client Json " + JSON.stringify(client));

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	console.log('Current auth token ' + authToken);
	var apsClientSignatureDate = new Date();
	var apsBuilderSignatureDate = new Date();
	var currentDate = new Date();

	var allMonths = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	var dateOfBirthNoTime = new dayjs(
		client?.documentInformation.document.individualDetails.dob
	).format('DD/MM/YYYY');

	var convertedPrice = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(buildingPrice);

	var closing_date = client?.documentInformation.document.closingDate;

	var test_date = dayjs(closing_date);
	console.log('Closing unix ' + test_date + ' unix ' + dayjs(test_date).unix());

	var second_closing_date = dayjs(closing_date).unix() * 1000 + 86400000 * 120; //.add(120, 'days');//Original Closing Date + 120 days:
	var firm_closing_date = dayjs(closing_date).unix() * 1000 + 86400000 * 240; //.add(240, 'days');//Original Closing Date + 240 Days:
	var outside_closing_date = dayjs(closing_date).unix() * 1000 + 86400000 * 605; //.add(605, 'days');//Original Closing Date + 240 days  + 365 days:
	var notice_delay = dayjs(closing_date).unix() * 1000 + 86400000 * -90; //.add(-90, 'days');// Original Closing Date - 90 days:
	var notice_second_delay = dayjs(closing_date).unix() * 1000 + 86400000 * 30; //.add(30, 'days');// Original Closing Date + 30 days
	var termination_date = dayjs(closing_date).unix() * 1000 + 86400000 * 635; //.add(635, 'days');// Original Closing date + 240 + 365 + 30:

	var jsonInfo = {
		authToken: authToken,
		senderEmail: adminEmail,
		subjectName: documentInfo.subjectName,
		message: documentInfo.message,
		projectCode: PROJECT_CODE.projectCode,
		templateId: documentInfo.buildingTemplateId[buildingName],
		clientEmail: client.clientEmail,
		clienFullName: client.fullName,
		customFields: [
			{
				'name': 'buyer_full_name',
				'value': client.fullName,
			},
			{
				'name': 'building_lot_number',
				'value': client.documentInformation.document.lotList[0].buildingLot,
			},
			// {
			//     'name': 'building_model_number',
			//     'value': client.documentInformation.document.elevationList[0]?.buildingName,
			// },
			// {
			// 	'name': 'irrevocable_day',
			// 	'value': client.documentInformation.document.irrevocableDate,
			// },
			{
				'name': 'closing_date',
				'value': dayjs(closing_date).format('DD/MM/YYYY'),
			},
			{
				'name': 'display_price_word',
				'value': buildingPriceWord,
			},
			{
				'name': 'buyer_dob',
				'value': dateOfBirthNoTime,
			},
			{
				'name': 'display_price_number',
				'value': convertedPrice,
			},
			{
				'name': 'client_address',
				'value': clientAddress,
			},
			{
				'name': 'client_email',
				'value': client.clientEmail,
			},
			{
				'name': 'client_phone',
				'value': client.phoneNumber,
			},
			{
				'name': 'building_elevation',
				'value': elevationId,
			},
			{
				'name': 'postal_code',
				'value': clientPostalCode,
			},
			{
				'name': 'second_closing_date',
				'value': dayjs(second_closing_date).format('DD/MM/YYYY'),
			},
			{
				'name': 'firm_closing_date',
				'value': dayjs(firm_closing_date).format('DD/MM/YYYY'),
			},
			{
				'name': 'outside_closing_date',
				'value': dayjs(outside_closing_date).format('DD/MM/YYYY'),
			},
			{
				'name': 'notice_delay',
				'value': dayjs(notice_delay).format('DD/MM/YYYY'),
			},
			{
				'name': 'notice_second_delay',
				'value': dayjs(notice_second_delay).format('DD/MM/YYYY'),
			},
			{
				'name': 'termination_date',
				'value': dayjs(termination_date).format('DD/MM/YYYY'),
			},
		],
	};

	if (
		secondIndividual?.firstName &&
		secondIndividual?.lastName &&
		secondIndividual?.email
	) {
		jsonInfo['secondClientFullName'] =
			secondIndividual.firstName + ' ' + secondIndividual.lastName;
		jsonInfo['secondClientEmail'] = secondIndividual.email;
		jsonInfo['templateId'] =
			documentInfo.secondPurchaserTemplateId[buildingName];
		getDoc = firebase
			.functions()
			.httpsCallable('HelloSignCallDocumentSecondPurchaser');

		var secondDOB = new dayjs(secondIndividual.dob).format('DD/MM/YYYY');

		var secondfDobJson = {
			'name': 'second_dob',
			'value': secondDOB,
		};

		var secondfFullNameJson = {
			'name': 'second_full_name',
			'value': secondIndividual.firstName + ' ' + secondIndividual.lastName,
		};

		jsonInfo.customFields.push(secondfDobJson);
		jsonInfo.customFields.push(secondfFullNameJson);
	}

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ' + signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: 'beab0930839f98ade6e9af78da0ed230',
		});
	};

	var finishedData;

	console.log('GetDocumentByInfoAPS line 268');

	helloClient.on('finish', async () => {
		await SaveClientSignatureRequestInfo(
			firebase,
			finishedData,
			client.clientEmail,
			ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo.subjectName
		);

		var clientRef = await firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					client.salesAgentPointer +
					'/myClients/' +
					client.keyValue +
					'/documentInformation'
			);

		clientRef.update({
			documentStatus: 'sent',
		});

		console.log('helloClient on finish line 285');

		window.location.pathname = '/clients';
	});

	helloClient.on('close', () => {
		setLoading(false);
	});

	helloClient.on('ready', () => {
		setLoading(false);
		var clientRef = firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					client.salesAgentPointer +
					'/myClients/' +
					client.keyValue +
					'/documentInformation'
			);

		clientRef.update({
			documentStatus: 'ready',
		});
	});
	getDoc(jsonInfo)
		.then((result) => {
			console.log('doc result: ' + JSON.stringify(result['data']['claim_url']));
			displayHelloDoc(result['data']['claim_url']);
			finishedData = result['data'];
			// SaveClientSignatureRequestInfo(
			// 	firebase,
			// 	result['data'],
			// 	client.clientEmail,
			// 	ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo.subjectName
			// );
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});
}

export async function GetDocumentByInfoCondoDoc(
	firebase,
	expandedClient,
	client,
	documentInfo,
	authToken,
	adminEmail,
	secondIndividual
) {
	//console.log("Client Json " + JSON.stringify(client));

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	console.log('Current auth token ' + authToken);
	var apsClientSignatureDate = new Date();
	var apsBuilderSignatureDate = new Date();
	var currentDate = new Date();

	//get the aps builder signature date

	var objBuilder = client.documentInformation.signatureRequests;

	var signatureRequestsKeys = Object.keys(objBuilder);

	var eventTime;
	var timeFound;
	var signatureObj;
	var builderArr = [];
	var signatureObjBuilder;
	var eventTimeObj;

	console.log('objBuilder ' + JSON.stringify(objBuilder));

	signatureRequestsKeys.forEach((key) => {
		var signatureUpdatesObj = objBuilder[key]?.signatureUpdates;

		console.log('signatureUpdatesObj ' + JSON.stringify(signatureUpdatesObj));

		var signatureUpdatesKeys = Object.keys(signatureUpdatesObj);

		console.log('signatureUpdatesKeys ' + JSON.stringify(signatureUpdatesKeys));

		console.log('signatureRequestsKeys ' + signatureUpdatesKeys);

		signatureUpdatesKeys.forEach((key) => {
			signatureObj = signatureUpdatesObj[key].signature_request.signatures;
			eventTime = signatureUpdatesObj[key].event.event_time;

			eventTimeObj = {
				eventTime: eventTime,
			};

			builderArr.push(eventTimeObj);

			var signatureObjKey = Object.keys(signatureObj);

			console.log('signatureObjKey ' + signatureObjKey);

			signatureObjKey.forEach((key) => {
				var signerRole = signatureObj[key].signer_role;
				var statusCode = signatureObj[key].status_code;

				if (signerRole === 'Builder' && timeFound === false) {
					signatureObjBuilder = {
						signerRole: signerRole,
						statusCode: statusCode,
					};

					if (statusCode === 'signed') {
						timeFound = true;
						apsBuilderSignatureDate = dayjs(
							parseInt(builderArr[0].eventTime) * 1000
						).format('DD MMMM YYYY HH:mm');
					}
					builderArr.push(signatureObjBuilder);
				}
			});
		});
	});

	console.log('apsBuilderSignatureDate: ' + apsBuilderSignatureDate);

	var clientArr = [];
	var clientTimeFound;
	var eventTimeClientObj;
	var signatureObjBuilderForClient;
	var signatureObjForClient;
	var eventTimeForClient;
	signatureRequestsKeys.forEach((key) => {
		var signatureUpdatesObj = objBuilder[key].signatureUpdates;

		var signatureUpdatesKeys = Object.keys(signatureUpdatesObj);

		console.log('signatureRequestsKeys ' + signatureUpdatesKeys);

		signatureUpdatesKeys.forEach((key) => {
			signatureObjForClient =
				signatureUpdatesObj[key].signature_request.signatures;
			eventTimeForClient = signatureUpdatesObj[key].event.event_time;

			eventTimeClientObj = {
				eventTime: eventTimeForClient,
			};

			clientArr.push(eventTimeClientObj);

			var signatureObjKey = Object.keys(signatureObjForClient);

			console.log('signatureObjKey ' + signatureObjKey);

			signatureObjKey.forEach((key) => {
				var signerRole = signatureObjForClient[key].signer_role;
				var statusCode = signatureObjForClient[key].status_code;

				if (signerRole === 'Client' && clientTimeFound === false) {
					signatureObjBuilderForClient = {
						signerRole: signerRole,
						statusCode: statusCode,
					};

					if (statusCode === 'signed') {
						clientTimeFound = true;
						apsClientSignatureDate = dayjs(
							parseInt(clientArr[0].eventTime) * 1000
						).format('DD MMMM YYYY HH:mm');
						console.log('Aps Client Sig Found time ' + apsClientSignatureDate);
					}
					clientArr.push(signatureObjBuilderForClient);
				}
			});
		});
	});

	console.log('apsClientSignatureDate: ' + apsClientSignatureDate);

	var allMonths = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	console.log(
		apsClientSignatureDate +
			' aps day month ' +
			allMonths[apsClientSignatureDate.getMonth()] +
			' | ' +
			apsClientSignatureDate.getDate() +
			' unix '
	);

	var jsonInfo = {
		authToken: authToken,
		senderEmail: adminEmail,
		subjectName: documentInfo.subjectName,
		message: documentInfo.message,
		projectCode: PROJECT_CODE.projectCode,
		templateId: documentInfo.templateId,
		clientEmail: client.clientEmail,
		clienFullName: client.fullName,
		customFields: [
			{
				'name': 'buyer_full_name',
				'value': client.fullName,
			},
			{
				'name': 'building_lot_number',
				'value': client.documentInformation.document.lotList[0].buildingLot,
			},
			{
				'name': 'buyer_day_month',
				'value':
					allMonths[apsClientSignatureDate.getMonth()] +
					' ' +
					apsClientSignatureDate.getDate(),
			},
			{
				'name': 'buyer_year',
				'value': apsClientSignatureDate.getFullYear(),
			},
			{
				'name': 'builder_day_month',
				'value':
					allMonths[apsBuilderSignatureDate.getMonth()] +
					' ' +
					apsBuilderSignatureDate.getDate(),
			},
			{
				'name': 'builder_year',
				'value': apsBuilderSignatureDate.getFullYear(),
			},
			{
				'name': 'this_year',
				'value': currentDate.getFullYear(),
			},
			{
				'name': 'this_month',
				'value': allMonths[currentDate.getMonth()],
			},
			{
				'name': 'today',
				'value': currentDate.getDate(),
			},
		],
	};

	if (
		secondIndividual?.firstName &&
		secondIndividual?.lastName &&
		secondIndividual?.email
	) {
		jsonInfo['secondClientFullName'] =
			secondIndividual.firstName + ' ' + secondIndividual.lastName;
		jsonInfo['secondClientEmail'] = secondIndividual.email;
		jsonInfo['templateId'] = documentInfo.secondPurchaserTemplateId;
		getDoc = firebase
			.functions()
			.httpsCallable('HelloSignCallDocumentSecondPurchaser');

		var secondfFullNameJson = {
			'name': 'second_full_name',
			'value': secondIndividual.firstName + ' ' + secondIndividual.lastName,
		};

		jsonInfo.customFields.push(secondfFullNameJson);
	}

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ' + signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: 'beab0930839f98ade6e9af78da0ed230',
		});
	};

	var finishedData;

	helloClient.on('finish', () => {
		var clientRef = firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					client.salesAgentPointer +
					'/myClients/' +
					client.keyValue +
					'/documentInformation'
			);

		clientRef.update({
			documentCondoStatus: 'sent',
		});

		console.log('hello client on finish');

		SaveClientSignatureRequestInfo(
			firebase,
			finishedData,
			client.clientEmail,
			ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo.subjectName
		);
	});

	getDoc(jsonInfo)
		.then((result) => {
			//setLoading(false);
			console.log('doc result: ' + JSON.stringify(result['data']['claim_url']));
			displayHelloDoc(result['data']['claim_url']);

			finishedData = result['data'];
			// SaveClientSignatureRequestInfo(
			// 	firebase,
			// 	result['data'],
			// 	client.clientEmail,
			// 	ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo.subjectName
			// );
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});
}

/* const hellosignOauth = require('hellosign-sdk')({
    key: 'ef5f3748a61baba67aefeca5fcfc2db8ebc107e78f1c432b9ad2a00758d41f15', client_id:"beab0930839f98ade6e9af78da0ed230", client_secret: '898ef63a5975418b2f2089cc0d129d3d'
});

var client_email = data.clientEmail;
var client_first_name_ = data.buyerFirstName;
var client_second_name_ = data.buyerSecondName;
var client_lot_number = data.buyer_lot_number;

var dateStart = new Date();

var current_year = "1";
var current_month = dateStart.getMonth();
var current_day = dateStart.getDate();

var allMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const opts = {
    test_mode: 1,
    clientId: 'beab0930839f98ade6e9af78da0ed230',
    subject: 'Condo Docs Ambria',
    template_id: '4383ed1c5de317d3c5b526057a00a1e295af5602',
    requester_email_address: 'twiggins@kavtek.com',
    message:
        'Please sign this NDA and then we can discuss more. Let me know if you have any questions.',
    signers: [
        {
            email_address: client_email,
            name: client_second_name_,
            role: 'Client',
        },
        {
            email_address: "kavtekrolead@gmail.com",
            name: "Test Admin",
            role: 'Admin',
        },
        {
            email_address: "kavtekrolebuilder@gmail.com",
            name: "Test Builder",
            role: 'Builder',
        }
    ],
    custom_fields: [
        {
            'name': 'buyer_full_name',
            'value': client_first_name_ + " " + client_second_name_,
        },
        {
            'name': 'building_lot_number',
            'value': client_lot_number,
        },
        {
            'name': 'buyer_day_month',
            'value': allMonths[current_month] + " " + current_day,
        },
        {
            'name': 'buyer_year',
            'value': current_year,
        },
        {
            'name': 'builder_day_month',
            'value': allMonths[current_month] + " " + current_day,
        },
        {
            'name': 'builder_year',
            'value': current_year,
        },
        {
            'name': 'this_year',
            'value': current_year,
        },
        {
            'name': 'this_month',
            'value': allMonths[current_month],
        },
        {
            'name': 'today',
            'value': current_day,
        },
    ],
    
}; */
